/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ResponseDocumentDto } from '../../models/response-document-dto';

export interface DocumentsControllerGetDocument$Params {

/**
 * Tenant ID
 */
  tenant: string;

/**
 * Document unique identifier
 */
  documentId: string;

/**
 * User ID requesting the document (for audit logging)
 */
  requestedBy?: string;
}

export function documentsControllerGetDocument(http: HttpClient, rootUrl: string, params: DocumentsControllerGetDocument$Params, context?: HttpContext): Observable<StrictHttpResponse<ResponseDocumentDto>> {
  const rb = new RequestBuilder(rootUrl, documentsControllerGetDocument.PATH, 'get');
  if (params) {
    rb.path('tenant', params.tenant, {});
    rb.path('documentId', params.documentId, {});
    rb.query('requestedBy', params.requestedBy, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ResponseDocumentDto>;
    })
  );
}

documentsControllerGetDocument.PATH = '/thalea-documents/documents/{tenant}/{documentId}';
